import { Box } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = {
	index: number;
	value: number;
};

export const CustomTabPanel: FC<PropsWithChildren<Props>> = ({
	children,
	index,
	value,
}) => (
	<div
		role="tabpanel"
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
	>
		{value === index && <Box>{children}</Box>}
	</div>
);
